import {React,useState} from 'react';
import styles from './Theme.module.css';
import { updateTheme } from '../api/form';

import theme1 from '../images/theme1.svg';
import theme2 from '../images/theme2.svg';
import theme3 from '../images/theme3.svg';
import sideright1 from '../images/sideright1.svg';
import sideright2 from '../images/sideright2.svg';
import sideright3 from '../images/sideright3.svg';

const Theme = (props) => {
  const [showTheme1, setShowTheme1] = useState(true);
  const [showTheme2, setShowTheme2] = useState(false);
  const [showTheme3, setShowTheme3] = useState(false);
  
  const handleclickResponse1 = () => {
const color1 = 0;
     updateTheme(props.formid, color1);
    setShowTheme1(true);
    setShowTheme2(false);
    setShowTheme3(false);
    
  };
  const handleclickResponse2 = () => {
    const color11 = 1; 
    updateTheme(props.formid, color11);
    setShowTheme1(false);
    setShowTheme2(true);
    setShowTheme3(false);
    
  };
  const handleclickResponse3 = () => {
    const color111 = 2;
    updateTheme(props.formid, color111);
    setShowTheme1(false);
    setShowTheme2(false);
    setShowTheme3(true);
    
  };

  return (
    <>
            
    <div>
     <div className={styles.sideleft}></div>
       <p className={styles.customizetheme}>Customize the theme</p>
      <hr/>
       <img className={showTheme1 ? styles.theme1selected : styles.theme1} src={theme1} alt="" onClick={handleclickResponse1}/>
      
       <img className={showTheme2 ? styles.theme2selected : styles.theme2} src={theme2} alt="" onClick={handleclickResponse2}/>
       
       <img className={showTheme3 ? styles.theme3selected : styles.theme3 } src={theme3} alt="" onClick={handleclickResponse3}/>
      <div className={styles.sideright}>
       

       <img className={styles.sideright1} src={ showTheme3 ? sideright3 : (showTheme2 ? sideright2 : sideright1) } alt=""/>
       {showTheme3 && <div className=''></div>}
      </div>
      
    </div>
   
</>
  );
};

export default Theme;
